import script from "./DrawerBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./DrawerBar.vue?vue&type=script&setup=true&lang=ts"

import "./DrawerBar.vue?vue&type=style&index=0&id=29217d33&lang=css"

const __exports__ = script;

export default __exports__